import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  "NAME": (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};

const duck = createDuck("ADD_SUBMODELO", newActions, newReducers);

const addSubmodeloThunk = (data) => {
  const url = `${baseUrl}/addSubmodelo`;
  return createThunk(axios, "post", duck.actions, url, data);
};



const duckEditSubmodelo = createDuck("EDIT_SUBMODELO", newActions, newReducers);

const editSubmodeloThunk = (data) => {
  const url = `${baseUrl}/updateSubmodelo`;
  return createThunk(axios, "post", duckEditSubmodelo.actions, url, data);
};

export default {
  duck,
  addSubmodeloThunk,
  duckEditSubmodelo,
  editSubmodeloThunk
};
